import { createSelector } from '@reduxjs/toolkit';

export const MARKER_SIZES = {
  sizeScale: 10, // this is the factor to scale the icon.
  sizeMinPixels: 30, // when zoomed out, the max height of the icon.
  sizeMaxPixels: 40, // when zoomed in, the max height of the icon.
};

export const LAYERS = {
  EAGLE_EYE: 'eagle_eye_camera_feeds',
};

// map to the png sprite used for EEN, it consists only of 2 icons
export const ICON_MAPPING = {
  cameraDefault: { x: 0, y: 0, width: 62, height: 64, mask: false },
  cameraSelected: { x: 62, y: 0, width: 62, height: 64, mask: false },
};

// for the future proofing keeping it as a more complex structure that a single dataset
export const getLatestDataset = datasets => {
  if (!datasets) {
    return;
  }
  const keys = Object.keys(datasets)
    .map(k => parseInt(k, 10))
    .sort((a, b) => a - b);
  const lastKey = [...keys].pop();
  return { topic: lastKey, dataset: datasets[lastKey] };
};

/**
 * Memoized selector to get the latest dataset from the given redux state.
 * Only recalculates when the eagleEye.datasets actually changes.
 * @usage const dataset = useSelector(selectLatestDataset);
 */
export const selectLatestDataset = createSelector(
  [state => state.eagleEye.datasets],
  datasets => getLatestDataset(datasets),
);
